import { FC, useState } from 'react'
import { HeaderCtaDialogProps } from './Dialogs.d'
import { Button } from 'react-bootstrap'
import { Dialog } from 'primereact/dialog'
import Cta from '../forms/fields/Cta'
import _ from 'lodash'
import { CtaType } from '../forms/Forms.d'
import { v4 as uuidv4 } from 'uuid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons'

const HeaderCtaDialog: FC<HeaderCtaDialogProps> = ({
    cta,
    formikProps,
    translations,
    availablePages,
    button,
    deletedCtas,
    setDeletedCtas,
    isNew,
}) => {
    const [visible, setVisible] = useState(false)
    const [ctaIsValid, setCtaIsValid] = useState(false)
    const [localCta, setLocalCta] = useState<CtaType>(cta)

    const [emptyCta] = useState<CtaType>({
        label: '',
        active: false,
        url_type: 'external',
        url: '',
        url_id: null,
        style: 'light',
        order: null,
    })

    return (
        <>
            <Button
                variant={button.variant}
                className="border position-relative"
                onClick={() => {
                    if (isNew) {
                        setLocalCta((prevState) => {
                            return {
                                ...prevState,
                                id: 'new-' + uuidv4(),
                            }
                        })
                    } else {
                        setLocalCta(cta)
                    }

                    setVisible(true)
                }}
            >
                {button.label || 'No label'}{' '}
                <span
                    className="position-absolute top-0 start-50 translate-middle rounded-pill"
                    style={{ zIndex: 10 }}
                >
                    {deletedCtas.includes(cta.id) ? (
                        <FontAwesomeIcon
                            icon={faTimesCircle}
                            className="bg-white text-danger rounded-circle"
                        />
                    ) : cta.active ? (
                        <FontAwesomeIcon
                            icon={faCheckCircle}
                            className="bg-white text-success rounded-circle"
                        />
                    ) : (
                        <></>
                    )}
                </span>
            </Button>
            <Dialog
                header={
                    isNew ? <>Create Header Action</> : <>Edit Header Action</>
                }
                visible={visible}
                breakpoints={{ '960px': '80vw', '640px': '100vw' }}
                style={{ width: '50vw' }}
                onHide={() => {
                    setVisible(false)
                    if (isNew && _.isEqual(emptyCta, cta) && !ctaIsValid) {
                        delete formikProps.values.ctas[localCta.id]
                        formikProps.setFieldValue('ctas', {
                            ...formikProps.values.ctas,
                        })
                    }
                }}
                closable={true}
            >
                <Cta
                    cta={localCta}
                    formikProps={formikProps}
                    translations={translations}
                    availablePages={availablePages}
                    setVisible={setVisible}
                    setDeletedCtas={setDeletedCtas}
                    deletedCtas={deletedCtas}
                    setCtaIsValid={setCtaIsValid}
                />
            </Dialog>
        </>
    )
}

export default HeaderCtaDialog
